const customSelect = () => {
    let customSelect = document.querySelectorAll("select");
    if (customSelect.length) {
        jcf.setOptions("Select", {
            wrapNative: false,
            fakeDropInBody: false,
            maxVisibleItems: 6,
            multipleCompactStyle: true
        });

        jcf.replaceAll();
    }
    $("input:reset, button:reset").on("click", function () {
        jcf.destroy(customSelect);
        jcf.replaceAll();
    });
};

export default customSelect;



// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js